import IconButton from '@/global/components/Button/IconButton'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { Tooltip } from '@/global/components/ui/tooltip'
import { Transaction } from '@cel_cash/core/types'
import { BarcodeIcon, RotateCcwIcon } from 'lucide-react'
import { useState } from 'react'
import { transacoes } from 'service/api'
import tokenRefresher from 'service/api/token-refresher'
import { toast } from 'sonner'

export function TransacaoButton({
    row,
}: GridCellParams<Transaction, Transaction>) {
    if (['denied', 'processError'].includes(row.status))
        return <BotaoTentarNovamente row={row} />
    if (['pendingBoleto', 'pendingPix'].includes(row.status))
        return <BotaoBoleto row={row} />
    return <></>
}

function BotaoBoleto({ row }: { row: Transaction }) {
    return (
        <Tooltip title="Visualizar boleto">
            <IconButton
                onClick={() => {
                    window.open(row.Boleto.pdf)
                }}
            >
                <BarcodeIcon />
            </IconButton>
        </Tooltip>
    )
}

function BotaoTentarNovamente({ row }: { row: Transaction }) {
    const [isRequesting, setIsRequesting] = useState(false)

    async function handleTentarNovamente() {
        setIsRequesting(true)
        return transacoes
            .retry(String(row.galaxPayId))
            .then(async res => {
                console.log({ res })
                if (res.status == 'denied')
                    return toast.error(res.statusDescription)

                if (res.status == 'captured') {
                    toast.success('Pagamento realizado com sucesso')
                    return tokenRefresher.refreshToken().then(() => {
                        window.location.reload()
                    })
                }

                return toast.info(res.statusDescription)
            })
            .catch(e => {
                toast.error(
                    e.message || 'Houve um erro ao processar sua transação',
                )
            })
            .finally(() => {
                setIsRequesting(false)
            })
    }

    return (
        <Tooltip title="Tentar cobrança novamente">
            <IconButton onClick={handleTentarNovamente} disabled={isRequesting}>
                <RotateCcwIcon />
            </IconButton>
        </Tooltip>
    )
}
